import React, { Component } from 'react';
import Layout from '../layout/Main'

export default class Vote extends Component {
  render() {
    return (
      <Layout>
        <iframe className="embed-responsive-item" src='https://suaraku.privy.id/petition/detail/3974666d-08aa-4ae8-b9b0-9f97c3b0b336' frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{width:'100%', height:'100vh'}}/>
      </Layout>
    )
  }
}
